import { render, staticRenderFns } from "./subject-form-5.vue?vue&type=template&id=4d998b57&scoped=true&"
import script from "./subject-form-5.vue?vue&type=script&lang=ts&"
export * from "./subject-form-5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d998b57",
  null
  
)

export default component.exports